import React from 'react'
import { WithdrawalList } from './list/page'

export const WithdrawalPage = (): JSX.Element => {
  return <WithdrawalList></WithdrawalList>
}
